import initReducer from "./reducers/initReducer";
import authReducer from "./reducers/authReducer";
import cardReducer from "./reducers/cardReducer";
import chatReducer from "./reducers/chatReducer";
import dashboardReducer from "./reducers/dashboardReducer";
import homeReducer from "./reducers/homeReducer";
import orderReducer from "./reducers/orderReducer";
import libroreclamacionesReducer from "./reducers/libroreclamacionesReducer";
import paymentReducer from "./reducers/paymentReducer";
import guestcartReducer from "./reducers/guestcartReducer";

const rootReducer = {
  init: initReducer,
  home: homeReducer,
  auth: authReducer,
  card: cardReducer,
  order: orderReducer,
  dashboard: dashboardReducer,
  chat: chatReducer,
  libroreclamaciones: libroreclamacionesReducer,
  payment: paymentReducer,
  guestcart: guestcartReducer,
};
export default rootReducer;
